import { BoardRoleEnum } from "enums/BoardRoleEnum";
import { BoardMembershipModel } from "models/BoardMembershipModel";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { UserLookupModel } from "models/UserLookupModel";
import { createContext } from "react";

export interface EditBoardGroupPanelContextProps {
  isOpen: boolean;
  role: BoardRoleEnum | null;
  isAdding: boolean;
  isLoading: boolean;
  deletingUserId: number | null;
  confirmDeleteMember: ConfirmDeleteTarget | undefined;
  members: BoardMembershipModel[];
  panelTitle: string;
  openEditBoardGroupPanel: (role: BoardRoleEnum) => void;
  closePanel: () => void;
  handleAdd: (user: UserLookupModel) => Promise<void>;
  reloadGroupMembers: () => void;
  setDeletingUserId: (userId: number | null) => void;
  setConfirmDeleteMember: (target: ConfirmDeleteTarget | undefined) => void;
}

export const EditBoardGroupPanelContext = createContext({} as EditBoardGroupPanelContextProps);
